import classNames from 'classnames';

import { useDefaultBrand } from '../../contexts/SiteContext';

import styles from '../../styles/icons/brand-logo-header.module.css';

import dehors from '../../assets/img/brands/dehors_header.svg';
import mollo from '../../assets/img/brands/mollo_header.svg';
import periodelibre from '../../assets/img/brands/periodelibre_header.svg';
import periodelibreVertical from '../../assets/img/brands/periodelibre_header_vertical.svg';
import quatre95 from '../../assets/img/brands/quatre95_header.svg';
import urbania from '../../assets/img/brands/urbania_header.png';

const brands = {
    urbania,
    dehors,
    quatre95,
    mollo,
    periodelibre,
    periodelibre_vertical: periodelibreVertical,
};

interface BrandLogoHeaderProps {
    brand?: string | null;
    vertical?: boolean | null;
    className?: string | null;
}

function BrandLogoHeader({
    brand = null,
    vertical = null,
    className = null,
}: BrandLogoHeaderProps) {
    const { handle: defaultBrandHandle = 'urbania' } = useDefaultBrand();
    const finalBrandHandle = brand || defaultBrandHandle;

    const logo =
        brands[vertical ? `${finalBrandHandle}_vertical` : finalBrandHandle] ||
        brands[finalBrandHandle];

    return (
        <img
            src={logo}
            className={classNames([styles.container, className || undefined])}
            alt="Logo"
        />
    );
}

export default BrandLogoHeader;
